import React from 'react';
import { Col } from 'antd';
import UserAvatar from '../UserAvatar';
import { LoggedInUserContainer, LoggedInUserRow, LoggedInUserCol } from './styles';
import Text from 'components/Core/Text';

const LoggedInUser = ({ userInfo, title, openLoginModal, Footer }) => {
  return (
    <LoggedInUserContainer>
      <Text type="h5">{title}</Text>
      <Text type="p" size="normal">
        You're currently signed in as
      </Text>
      <LoggedInUserRow>
        <LoggedInUserCol flex="1 0 75%">
          <UserAvatar userInfo={userInfo} width="50" height="50" />
          <Text type="p">
            {userInfo.firstName} {userInfo.lastName}
          </Text>
        </LoggedInUserCol>
        <LoggedInUserCol flex="1 0 25%" style={{ textAlign: 'right' }}>
          <Text type="p">
            <a
              onClick={() => {
                openLoginModal();
                return false;
              }}
            >
              Not you?
            </a>
          </Text>
        </LoggedInUserCol>
      </LoggedInUserRow>
      {Footer && <Footer />}
    </LoggedInUserContainer>
  );
};

export default LoggedInUser;
